export default __webpack_public_path__ + "static/media/spritzlight_02.798b61eb.png";